import { render } from "./navbar-blog.vue?vue&type=template&id=d04ffb12&scoped=true"
import script from "./navbar-blog.vue?vue&type=script&lang=js"
export * from "./navbar-blog.vue?vue&type=script&lang=js"

import "./navbar-blog.vue?vue&type=style&index=0&id=d04ffb12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d04ffb12"]])

export default __exports__